{
  "account.delete-confirm": [
    {
      "type": 0,
      "value": "Eliminar Cuenta"
    }
  ],
  "account.delete-confirmation-instruction": [
    {
      "type": 0,
      "value": "Por favor, escribe ELIMINAR MI CUENTA para confirmar:"
    }
  ],
  "account.delete-confirmation-title": [
    {
      "type": 0,
      "value": "¿Estás absolutamente seguro?"
    }
  ],
  "account.delete-confirmation-warning": [
    {
      "type": 0,
      "value": "Esta acción no se puede deshacer. Esto eliminará permanentemente tu cuenta y removerá todos los datos de nuestros servidores."
    }
  ],
  "account.delete-warning": [
    {
      "type": 0,
      "value": "Tenga en cuenta que no podrá recuperar ningún mapa mental que haya creado. Toda su información será eliminada y no podrá ser restaurada."
    }
  ],
  "account.delete-warning-collaborations": [
    {
      "type": 0,
      "value": "Todos los mapas mentales compartidos y colaboraciones"
    }
  ],
  "account.delete-warning-consequences": [
    {
      "type": 0,
      "value": "Esto eliminará permanentemente:"
    }
  ],
  "account.delete-warning-data": [
    {
      "type": 0,
      "value": "Todos tus datos personales e información de cuenta"
    }
  ],
  "account.delete-warning-description": [
    {
      "type": 0,
      "value": "Una vez que elimines tu cuenta, no hay vuelta atrás. Por favor, ten certeza."
    }
  ],
  "account.delete-warning-history": [
    {
      "type": 0,
      "value": "Todo el historial de cuenta y registros de actividad"
    }
  ],
  "account.delete-warning-mindmaps": [
    {
      "type": 0,
      "value": "Todos tus mapas mentales y su contenido"
    }
  ],
  "account.delete-warning-title": [
    {
      "type": 0,
      "value": "Eliminar Cuenta"
    }
  ],
  "accountinfo.button": [
    {
      "type": 0,
      "value": "Aceptar"
    }
  ],
  "accountinfo.deleteaccount": [
    {
      "type": 0,
      "value": "Eliminar cuenta"
    }
  ],
  "accountinfo.email": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "accountinfo.firstname": [
    {
      "type": 0,
      "value": "Primer nombre"
    }
  ],
  "accountinfo.lastname": [
    {
      "type": 0,
      "value": "Apellido"
    }
  ],
  "accountinfo.personal-details": [
    {
      "type": 0,
      "value": "Detalles Personales"
    }
  ],
  "accountinfo.title": [
    {
      "type": 0,
      "value": "Informacion de cuenta"
    }
  ],
  "action.cancel-button": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "action.close-button": [
    {
      "type": 0,
      "value": "Cerrar"
    }
  ],
  "action.delete": [
    {
      "type": 0,
      "value": "Borrar"
    }
  ],
  "action.delete-description": [
    {
      "type": 0,
      "value": "El mapa mental eliminado no se podrá recuperar. ¿Quieres continuar?"
    }
  ],
  "action.delete-title": [
    {
      "type": 0,
      "value": "Borrar"
    }
  ],
  "action.duplicate": [
    {
      "type": 0,
      "value": "Duplicar"
    }
  ],
  "action.export": [
    {
      "type": 0,
      "value": "Exportar"
    }
  ],
  "action.history": [
    {
      "type": 0,
      "value": "Historia"
    }
  ],
  "action.history-description": [
    {
      "type": 0,
      "value": "Lista de cambios introducidos en los últimos 90 días."
    }
  ],
  "action.history-title": [
    {
      "type": 0,
      "value": "Historial de versiones"
    }
  ],
  "action.import": [
    {
      "type": 0,
      "value": "Importar"
    }
  ],
  "action.info": [
    {
      "type": 0,
      "value": "Información"
    }
  ],
  "action.label": [
    {
      "type": 0,
      "value": "Añadir etiqueta"
    }
  ],
  "action.new": [
    {
      "type": 0,
      "value": "Nuevo mapa"
    }
  ],
  "action.open": [
    {
      "type": 0,
      "value": "Abrir"
    }
  ],
  "action.print": [
    {
      "type": 0,
      "value": "Imprimir"
    }
  ],
  "action.publish": [
    {
      "type": 0,
      "value": "Publicar"
    }
  ],
  "action.rename": [
    {
      "type": 0,
      "value": "Renombar"
    }
  ],
  "action.rename-description-placeholder": [
    {
      "type": 0,
      "value": "Descripción"
    }
  ],
  "action.rename-name-placeholder": [
    {
      "type": 0,
      "value": "Nombre"
    }
  ],
  "action.share": [
    {
      "type": 0,
      "value": "Compartir"
    }
  ],
  "activation.error.message": [
    {
      "type": 0,
      "value": "We couldn't activate your account. The activation link may be invalid or expired. Please contact support for assistance."
    }
  ],
  "activation.error.title": [
    {
      "type": 0,
      "value": "Activation Failed"
    }
  ],
  "activation.loading.desc": [
    {
      "type": 0,
      "value": "Please wait while we activate your account..."
    }
  ],
  "activation.loading.title": [
    {
      "type": 0,
      "value": "Activating Your Account"
    }
  ],
  "activation.success.message": [
    {
      "type": 0,
      "value": "Your account has been activated. You can now sign in and start creating mind maps."
    }
  ],
  "activation.success.title": [
    {
      "type": 0,
      "value": "Account Activated Successfully"
    }
  ],
  "admin.auth-type": [
    {
      "type": 0,
      "value": "Tipo de autenticación"
    }
  ],
  "admin.change-password": [
    {
      "type": 0,
      "value": "Change password"
    }
  ],
  "admin.change-password-button": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.change-password-description": [
    {
      "type": 0,
      "value": "Change password for user: "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "admin.change-password-title": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "admin.confirm-password": [
    {
      "type": 0,
      "value": "Confirm Password"
    }
  ],
  "admin.delete": [
    {
      "type": 0,
      "value": "Eliminar"
    }
  ],
  "admin.delete-user": [
    {
      "type": 0,
      "value": "Eliminar usuario"
    }
  ],
  "admin.edit": [
    {
      "type": 0,
      "value": "Editar"
    }
  ],
  "admin.edit-user": [
    {
      "type": 0,
      "value": "Editar usuario"
    }
  ],
  "admin.lock-status": [
    {
      "type": 0,
      "value": "Estado de bloqueo"
    }
  ],
  "admin.locked": [
    {
      "type": 0,
      "value": "Bloqueado"
    }
  ],
  "admin.new-password": [
    {
      "type": 0,
      "value": "New Password"
    }
  ],
  "admin.password-error-facebook": [
    {
      "type": 0,
      "value": "This user is authenticated via Facebook. Password changes are not available for Facebook accounts. Please ask the user to manage their password through their Facebook account."
    }
  ],
  "admin.password-error-failed": [
    {
      "type": 0,
      "value": "Failed to change password"
    }
  ],
  "admin.password-error-google": [
    {
      "type": 0,
      "value": "This user is authenticated via Google. Password changes are not available for Google accounts. Please ask the user to manage their password through their Google account."
    }
  ],
  "admin.password-error-length": [
    {
      "type": 0,
      "value": "Password must be at least 6 characters"
    }
  ],
  "admin.password-error-mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match"
    }
  ],
  "admin.public": [
    {
      "type": 0,
      "value": "Público"
    }
  ],
  "admin.public-access": [
    {
      "type": 0,
      "value": "Acceso público"
    }
  ],
  "admin.refresh": [
    {
      "type": 0,
      "value": "Actualizar"
    }
  ],
  "admin.status": [
    {
      "type": 0,
      "value": "Estado"
    }
  ],
  "admin.status-active": [
    {
      "type": 0,
      "value": "Activo"
    }
  ],
  "admin.status-clean": [
    {
      "type": 0,
      "value": "Limpiar"
    }
  ],
  "admin.status-suspended": [
    {
      "type": 0,
      "value": "Suspendido"
    }
  ],
  "admin.suspend-user": [
    {
      "type": 0,
      "value": "Suspender usuario"
    }
  ],
  "admin.suspension-reason": [
    {
      "type": 0,
      "value": "Razón de suspensión"
    }
  ],
  "admin.suspension-status": [
    {
      "type": 0,
      "value": "Estado de suspensión"
    }
  ],
  "admin.suspension.abuse": [
    {
      "type": 0,
      "value": "Abuso"
    }
  ],
  "admin.suspension.inactivity": [
    {
      "type": 0,
      "value": "Inactividad"
    }
  ],
  "admin.suspension.manual-review": [
    {
      "type": 0,
      "value": "Revisión manual"
    }
  ],
  "admin.suspension.other": [
    {
      "type": 0,
      "value": "Otro"
    }
  ],
  "admin.suspension.security-concern": [
    {
      "type": 0,
      "value": "Preocupación de seguridad"
    }
  ],
  "admin.suspension.terms-violation": [
    {
      "type": 0,
      "value": "Violación de términos"
    }
  ],
  "admin.system.db.url": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "admin.system.jvm": [
    {
      "type": 0,
      "value": "JVM"
    }
  ],
  "admin.system.memory": [
    {
      "type": 0,
      "value": "Memoria"
    }
  ],
  "admin.system.refresh": [
    {
      "type": 0,
      "value": "Actualizar"
    }
  ],
  "admin.system.title": [
    {
      "type": 0,
      "value": "Información del Sistema"
    }
  ],
  "admin.unsuspend-user": [
    {
      "type": 0,
      "value": "Reactivar usuario"
    }
  ],
  "admin.view-xml": [
    {
      "type": 0,
      "value": "Ver XML"
    }
  ],
  "changepwd.confirm-password": [
    {
      "type": 0,
      "value": "Confirmar contraseña"
    }
  ],
  "changepwd.description": [
    {
      "type": 0,
      "value": "Por favor, proporcione la nueva contraseña para su cuenta."
    }
  ],
  "changepwd.password": [
    {
      "type": 0,
      "value": "Contraseña"
    }
  ],
  "changepwd.password-match": [
    {
      "type": 0,
      "value": "La contraseña no coincide. Inténtalo de nuevo."
    }
  ],
  "changepwd.title": [
    {
      "type": 0,
      "value": "Cambia la contraseña"
    }
  ],
  "common.allow-email-notifications": [
    {
      "type": 0,
      "value": "Permitir notificaciones por correo"
    }
  ],
  "common.delete": [
    {
      "type": 0,
      "value": "Eliminar"
    }
  ],
  "common.delete-tag": [
    {
      "type": 0,
      "value": "Eliminar etiqueta"
    }
  ],
  "common.email": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "common.emails": [
    {
      "type": 0,
      "value": "Correos electrónicos"
    }
  ],
  "common.first-name": [
    {
      "type": 0,
      "value": "Nombre"
    }
  ],
  "common.last-name": [
    {
      "type": 0,
      "value": "Apellido"
    }
  ],
  "common.loading": [
    {
      "type": 0,
      "value": "Cargando..."
    }
  ],
  "common.locale": [
    {
      "type": 0,
      "value": "Idioma"
    }
  ],
  "common.login-form": [
    {
      "type": 0,
      "value": "Formulario de inicio de sesión"
    }
  ],
  "common.maps-list": [
    {
      "type": 0,
      "value": "Lista de mapas"
    }
  ],
  "common.open-drawer": [
    {
      "type": 0,
      "value": "Abrir menú"
    }
  ],
  "common.others": [
    {
      "type": 0,
      "value": "Otros"
    }
  ],
  "common.refresh": [
    {
      "type": 0,
      "value": "Actualizar"
    }
  ],
  "common.registration-form": [
    {
      "type": 0,
      "value": "Formulario de registro"
    }
  ],
  "common.retry": [
    {
      "type": 0,
      "value": "Reintentar"
    }
  ],
  "common.settings": [
    {
      "type": 0,
      "value": "Configuración"
    }
  ],
  "common.terms-notice": [
    {
      "type": 0,
      "value": "Al continuar, aceptas nuestros "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Términos de Uso"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " y "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Política de Privacidad"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "common.wait": [
    {
      "type": 0,
      "value": "Espere por favor ..."
    }
  ],
  "create.button": [
    {
      "type": 0,
      "value": "Crear"
    }
  ],
  "create.description": [
    {
      "type": 0,
      "value": "Por favor, complete el nuevo nombre y descripción del mapa."
    }
  ],
  "create.title": [
    {
      "type": 0,
      "value": "Crea un nuevo mapa mental."
    }
  ],
  "deletem.title": [
    {
      "type": 0,
      "value": "Todos los mapas seleccionados serán eliminados"
    }
  ],
  "dialog.loading": [
    {
      "type": 0,
      "value": "Cargando ..."
    }
  ],
  "duplicate.copy-prefix": [
    {
      "type": 0,
      "value": "Copia de "
    }
  ],
  "duplicate.title": [
    {
      "type": 0,
      "value": "Duplicar"
    }
  ],
  "error.contact-support": [
    {
      "type": 0,
      "value": "¿Necesitas ayuda? Contáctanos en "
    },
    {
      "type": 1,
      "value": "support"
    }
  ],
  "error.generic-message": [
    {
      "type": 0,
      "value": "Inténtalo de nuevo más tarde o contacta al soporte si el problema continúa."
    }
  ],
  "error.generic-title": [
    {
      "type": 0,
      "value": "Hemos encontrado un problema."
    }
  ],
  "error.go-back": [
    {
      "type": 0,
      "value": "Go Back"
    }
  ],
  "error.go-home": [
    {
      "type": 0,
      "value": "Go to Home"
    }
  ],
  "error.go-to-login": [
    {
      "type": 0,
      "value": "Sign In"
    }
  ],
  "error.map-title-required": [
    {
      "type": 0,
      "value": "El título del mapa es obligatorio y no puede estar vacío"
    }
  ],
  "error.map-unavailable-message": [
    {
      "type": 0,
      "value": "Este mapa mental no está disponible para visualización pública porque viola nuestras políticas del sitio. Si necesita más ayuda, contacte a support@wisemapping.com."
    }
  ],
  "error.map-unavailable-title": [
    {
      "type": 0,
      "value": "Este mapa mental no está disponible para visualización pública."
    }
  ],
  "error.not-found-message": [
    {
      "type": 0,
      "value": "Es posible que la página haya sido eliminada, haya cambiado de nombre o no esté disponible temporalmente."
    }
  ],
  "error.not-found-title": [
    {
      "type": 0,
      "value": "No encontramos esa página."
    }
  ],
  "error.page-title": [
    {
      "type": 0,
      "value": "Error Inesperado | WiseMapping"
    }
  ],
  "error.permission-denied-message": [
    {
      "type": 0,
      "value": "Si crees que deberías tener acceso, ponte en contacto con tu administrador."
    }
  ],
  "error.permission-denied-title": [
    {
      "type": 0,
      "value": "No tienes acceso a esta página."
    }
  ],
  "expired.description": [
    {
      "type": 0,
      "value": "Su sesión actual ha expirado. Por favor, inicia sesión e inténtalo de nuevo."
    }
  ],
  "expired.title": [
    {
      "type": 0,
      "value": "Su sesión ha caducado"
    }
  ],
  "export.desc": [
    {
      "type": 0,
      "value": "Exporta este mapa en el formato que desees y comienza a usarlo en tus presentaciones o compartirlo por correo electrónico"
    }
  ],
  "export.document": [
    {
      "type": 0,
      "value": "Herramientas de mapas mentales: exporte su mapa mental en formatos de herramientas de mapas mentales de terceros"
    }
  ],
  "export.document-label": [
    {
      "type": 0,
      "value": "Documento: exporte su mapa mental en un documento independiente listo para compartir"
    }
  ],
  "export.image": [
    {
      "type": 0,
      "value": "Imagen: obtenga una representación gráfica de su mapa, incluidos todos los colores y formas."
    }
  ],
  "export.img-center": [
    {
      "type": 0,
      "value": "Centrar y ajustar zoom"
    }
  ],
  "export.title": [
    {
      "type": 0,
      "value": "Exportar"
    }
  ],
  "export.warning": [
    {
      "type": 0,
      "value": "El export a formatos de imagen (SVG, PNG, JPEG, PDF) solo está disponible en la barra de herramientas del editor."
    }
  ],
  "footer.aboutus": [
    {
      "type": 0,
      "value": "Sobre Nosotros"
    }
  ],
  "footer.col-community": [
    {
      "type": 0,
      "value": "Comunidad"
    }
  ],
  "footer.col-company": [
    {
      "type": 0,
      "value": "Empresa"
    }
  ],
  "footer.col-support": [
    {
      "type": 0,
      "value": "Soporte"
    }
  ],
  "footer.contactus": [
    {
      "type": 0,
      "value": "Contáctenos"
    }
  ],
  "footer.copyright": [
    {
      "type": 0,
      "value": "© "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " WiseMapping LLC"
    }
  ],
  "footer.donations": [
    {
      "type": 0,
      "value": "Donaciones"
    }
  ],
  "footer.faq": [
    {
      "type": 0,
      "value": "F.A.Q."
    }
  ],
  "footer.feedback": [
    {
      "type": 0,
      "value": "Feedback"
    }
  ],
  "footer.news": [
    {
      "type": 0,
      "value": "Noticias"
    }
  ],
  "footer.opensource": [
    {
      "type": 0,
      "value": "Código Abierto"
    }
  ],
  "footer.privacypolicy": [
    {
      "type": 0,
      "value": "Política de Privacidad"
    }
  ],
  "footer.termsandconditions": [
    {
      "type": 0,
      "value": "Términos y Condiciones"
    }
  ],
  "footer.twitter": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "forgot.desc": [
    {
      "type": 0,
      "value": "Le enviaremos un correo electrónico para restablecer su contraseña."
    }
  ],
  "forgot.email": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "forgot.oauth.back": [
    {
      "type": 0,
      "value": "Volver"
    }
  ],
  "forgot.oauth.message": [
    {
      "type": 0,
      "value": "No necesitas contraseña, por favor ingresa usando Facebook o Google"
    }
  ],
  "forgot.page-title": [
    {
      "type": 0,
      "value": "Olvidé mi contraseña | WiseMapping"
    }
  ],
  "forgot.register": [
    {
      "type": 0,
      "value": "Enviar enlace de recuperación"
    }
  ],
  "forgot.success.desc": [
    {
      "type": 0,
      "value": "Le hemos enviado un correo electrónico que le permitirá restablecer su contraseña. Deberías recibirlo en los próximos minutos."
    }
  ],
  "forgot.success.title": [
    {
      "type": 0,
      "value": "Su contraseña temporal ha sido enviada."
    }
  ],
  "forgot.title": [
    {
      "type": 0,
      "value": "Restablecer su contraseña"
    }
  ],
  "forgotsuccess.page-title": [
    {
      "type": 0,
      "value": "Contraseña recuperada | WiseMapping"
    }
  ],
  "header.donthaveaccount": [
    {
      "type": 0,
      "value": "¿No tienes una cuenta?"
    }
  ],
  "header.haveaccount": [
    {
      "type": 0,
      "value": "¿Ya tienes una cuenta?"
    }
  ],
  "help.support": [
    {
      "type": 0,
      "value": "Ayuda"
    }
  ],
  "history.no-changes": [
    {
      "type": 0,
      "value": "No hay cambios disponibles"
    }
  ],
  "import.button": [
    {
      "type": 0,
      "value": "Crear"
    }
  ],
  "import.description": [
    {
      "type": 0,
      "value": "Puede importar mapas de WiseMapping, FreeMind, Freeplane, XMind, MindManager y OPML a su lista de mapas. Seleccione el archivo que desea importar."
    }
  ],
  "import.error-file": [
    {
      "type": 0,
      "value": "Error al importar: "
    },
    {
      "type": 1,
      "value": "error"
    }
  ],
  "import.title": [
    {
      "type": 0,
      "value": "Importar mapa mental existente"
    }
  ],
  "info.basic-info": [
    {
      "type": 0,
      "value": "Información básica"
    }
  ],
  "info.button": [
    {
      "type": 0,
      "value": "Aceptar"
    }
  ],
  "info.creation-time": [
    {
      "type": 0,
      "value": "Fecha de creación"
    }
  ],
  "info.creator": [
    {
      "type": 0,
      "value": "Creador"
    }
  ],
  "info.description": [
    {
      "type": 0,
      "value": "Descripción"
    }
  ],
  "info.description-msg": [
    {
      "type": 0,
      "value": "Al publicar el mapa, lo haces visible para todos en Internet."
    }
  ],
  "info.modified-time": [
    {
      "type": 0,
      "value": "Última fecha de modificación"
    }
  ],
  "info.modified-tny": [
    {
      "type": 0,
      "value": "Ultima modificacion por"
    }
  ],
  "info.name": [
    {
      "type": 0,
      "value": "Nombre"
    }
  ],
  "info.public-visibility": [
    {
      "type": 0,
      "value": "Visible públicamente"
    }
  ],
  "info.sharing": [
    {
      "type": 0,
      "value": "Compartido"
    }
  ],
  "info.starred": [
    {
      "type": 0,
      "value": "Destacados"
    }
  ],
  "info.title": [
    {
      "type": 0,
      "value": "Información"
    }
  ],
  "label.add-button": [
    {
      "type": 0,
      "value": "Agregar etiqueta"
    }
  ],
  "label.add-for": [
    {
      "type": 0,
      "value": "Editando etiquetas para el mapa:"
    }
  ],
  "label.add-placeholder": [
    {
      "type": 0,
      "value": "Título"
    }
  ],
  "label.change-color": [
    {
      "type": 0,
      "value": "Cambiar el color"
    }
  ],
  "label.delete-description": [
    {
      "type": 0,
      "value": "será borrado de todos los mapas a los que se encuentra asociado. Desea continuar?"
    }
  ],
  "label.delete-title": [
    {
      "type": 0,
      "value": "Confirmación"
    }
  ],
  "label.description": [
    {
      "type": 0,
      "value": "Usa las etiquetas para organizar tus mapas."
    }
  ],
  "label.maps-count": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " mapas"
    }
  ],
  "label.title": [
    {
      "type": 0,
      "value": "Agregar etiqueta"
    }
  ],
  "language.change": [
    {
      "type": 0,
      "value": "Cambiar idioma"
    }
  ],
  "language.help": [
    {
      "type": 0,
      "value": "Ayuda para traducir"
    }
  ],
  "login.desc": [
    {
      "type": 0,
      "value": "Ingrese a su cuenta"
    }
  ],
  "login.division": [
    {
      "type": 0,
      "value": "ó"
    }
  ],
  "login.email": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "login.error": [
    {
      "type": 0,
      "value": "La dirección de correo electrónico o la contraseña que ingresó no es válida."
    }
  ],
  "login.facebook.button": [
    {
      "type": 0,
      "value": "Iniciar sesión con Facebook"
    }
  ],
  "login.forgotpwd": [
    {
      "type": 0,
      "value": "Has olvidado tu contraseña ?"
    }
  ],
  "login.generic-error": [
    {
      "type": 0,
      "value": "An error occurred during authentication. Please try again."
    }
  ],
  "login.google.button": [
    {
      "type": 0,
      "value": "Ingresar con Google"
    }
  ],
  "login.oauth-error": [
    {
      "type": 0,
      "value": "OAuth authentication failed. Please try again or use a different sign-in method."
    }
  ],
  "login.page-title": [
    {
      "type": 0,
      "value": "Iniciar sesión | WiseMapping"
    }
  ],
  "login.password": [
    {
      "type": 0,
      "value": "Contraseña"
    }
  ],
  "login.redirecting": [
    {
      "type": 0,
      "value": "Redirigiendo..."
    }
  ],
  "login.server-error": [
    {
      "type": 0,
      "value": "An unexpected error occurred. Please try again later."
    }
  ],
  "login.shared-map-notice": [
    {
      "type": 0,
      "value": "Un mapa mental ha sido compartido contigo. Por favor inicia sesión para acceder a él. ¿No tienes cuenta? Regístrate gratis o usa tu cuenta de Google/Facebook."
    }
  ],
  "login.signin": [
    {
      "type": 0,
      "value": "Iniciar sesión"
    }
  ],
  "login.signup": [
    {
      "type": 0,
      "value": "Crear cuenta"
    }
  ],
  "login.title": [
    {
      "type": 0,
      "value": "Bienvenido"
    }
  ],
  "map.creator": [
    {
      "type": 0,
      "value": "Creador"
    }
  ],
  "map.delete-selected": [
    {
      "type": 0,
      "value": "Eliminar seleccionado"
    }
  ],
  "map.last-update": [
    {
      "type": 0,
      "value": "Última actualización"
    }
  ],
  "map.more-actions": [
    {
      "type": 0,
      "value": "Mas acciones"
    }
  ],
  "map.name": [
    {
      "type": 0,
      "value": "Nombre"
    }
  ],
  "map.tooltip-add": [
    {
      "type": 0,
      "value": "Agregar etiqueta a lo seleccionado"
    }
  ],
  "maps.auth-required-default-message": [
    {
      "type": 0,
      "value": "You need to sign in to view your maps."
    }
  ],
  "maps.auth-required-heading": [
    {
      "type": 0,
      "value": "Sign in to access your maps"
    }
  ],
  "maps.auth-required-login": [
    {
      "type": 0,
      "value": "Go to login"
    }
  ],
  "maps.auth-required-title": [
    {
      "type": 0,
      "value": "Sign In Required | WiseMapping"
    }
  ],
  "maps.choose-file": [
    {
      "type": 0,
      "value": "Escoge un archivo"
    }
  ],
  "maps.copilot-button": [
    {
      "type": 0,
      "value": "Copiloto IA"
    }
  ],
  "maps.copilot-dialog.continue": [
    {
      "type": 0,
      "value": "Abrir Copiloto"
    }
  ],
  "maps.copilot-dialog.description": [
    {
      "type": 0,
      "value": "Mind Map Copilot es un asistente de lluvia de ideas impulsado por ChatGPT que convierte tus indicaciones en mapas mentales estructurados. Lo abriremos en una nueva pestaña para que amplíes ideas, generes temas y traigas lo mejor de regreso a WiseMapping."
    }
  ],
  "maps.copilot-dialog.title": [
    {
      "type": 0,
      "value": "Copiloto de mapas mentales impulsado por ChatGPT"
    }
  ],
  "maps.copilot-tooltip": [
    {
      "type": 0,
      "value": "Inicia un mapa mental con el Copiloto IA"
    }
  ],
  "maps.create-tooltip": [
    {
      "type": 0,
      "value": "Crear un nuevo mapa mental"
    }
  ],
  "maps.empty-result": [
    {
      "type": 0,
      "value": "No se encontró ningún mapa mental coincidente con los criterios de filtro actuales."
    }
  ],
  "maps.import-desc": [
    {
      "type": 0,
      "value": "Importar desde otras herramientas"
    }
  ],
  "maps.modified": [
    {
      "type": 0,
      "value": "Modificado"
    }
  ],
  "maps.modified-by": [
    {
      "type": 0,
      "value": "Modificado por"
    }
  ],
  "maps.modified-by-desc": [
    {
      "type": 0,
      "value": "Modificado por "
    },
    {
      "type": 1,
      "value": "by"
    },
    {
      "type": 0,
      "value": " el "
    },
    {
      "type": 1,
      "value": "on"
    }
  ],
  "maps.nav-all": [
    {
      "type": 0,
      "value": "Todos"
    }
  ],
  "maps.nav-onwned": [
    {
      "type": 0,
      "value": "Mis Mapas"
    }
  ],
  "maps.nav-public": [
    {
      "type": 0,
      "value": "Públicos"
    }
  ],
  "maps.nav-shared": [
    {
      "type": 0,
      "value": "Compartidos"
    }
  ],
  "maps.nav-starred": [
    {
      "type": 0,
      "value": "Destacados"
    }
  ],
  "maps.page-title": [
    {
      "type": 0,
      "value": "Mis Mapas | WiseMapping"
    }
  ],
  "maps.revert": [
    {
      "type": 0,
      "value": "Revertir"
    }
  ],
  "maps.search-action": [
    {
      "type": 0,
      "value": "Buscar ..."
    }
  ],
  "maps.tooltip-open": [
    {
      "type": 0,
      "value": "Abrir para edición"
    }
  ],
  "maps.tooltip-starred": [
    {
      "type": 0,
      "value": "Destacados"
    }
  ],
  "maps.view": [
    {
      "type": 0,
      "value": "Vista"
    }
  ],
  "menu.account": [
    {
      "type": 0,
      "value": "Información de cuenta"
    }
  ],
  "menu.admin-console": [
    {
      "type": 0,
      "value": "Consola de Administración"
    }
  ],
  "menu.change-password": [
    {
      "type": 0,
      "value": "Cambia la contraseña"
    }
  ],
  "menu.signout": [
    {
      "type": 0,
      "value": "Cerrar sesión"
    }
  ],
  "publish.checkbox": [
    {
      "type": 0,
      "value": "Habilitar el uso compartido público"
    }
  ],
  "publish.copied": [
    {
      "type": 0,
      "value": "¡Copiado al portapapeles!"
    }
  ],
  "publish.description": [
    {
      "type": 0,
      "value": "Haz tu mapa público. Cualquiera con el enlace puede verlo."
    }
  ],
  "publish.embedded": [
    {
      "type": 0,
      "value": "Incrustado"
    }
  ],
  "publish.embedded-msg": [
    {
      "type": 0,
      "value": "Haz clic en el código para copiarlo al portapapeles:"
    }
  ],
  "publish.public-url": [
    {
      "type": 0,
      "value": "URL pública"
    }
  ],
  "publish.public-url-msg": [
    {
      "type": 0,
      "value": "Haz clic en el enlace para copiarlo al portapapeles:"
    }
  ],
  "publish.title": [
    {
      "type": 0,
      "value": "Publicar"
    }
  ],
  "registation.success-title": [
    {
      "type": 0,
      "value": "Éxito de registro | WiseMapping"
    }
  ],
  "registration.callback.back": [
    {
      "type": 0,
      "value": "Volver"
    }
  ],
  "registration.callback.confirm.description": [
    {
      "type": 0,
      "value": "Una cuenta con el mismo email fue registrada previamente. ¿Quieres asociar tu cuenta de "
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": " con esa cuenta de WiseMapping?"
    }
  ],
  "registration.callback.confirm.title": [
    {
      "type": 0,
      "value": "Confirmación"
    }
  ],
  "registration.callback.sync": [
    {
      "type": 0,
      "value": "Sincronizar cuenta"
    }
  ],
  "registration.callback.waiting.description": [
    {
      "type": 0,
      "value": "Por favor espera mientras validamos tu identidad"
    }
  ],
  "registration.callback.waiting.title": [
    {
      "type": 0,
      "value": "Finalizando ..."
    }
  ],
  "registration.desc": [
    {
      "type": 0,
      "value": "Registrarse es gratis y solo tómese un momento"
    }
  ],
  "registration.division": [
    {
      "type": 0,
      "value": "ó"
    }
  ],
  "registration.email": [
    {
      "type": 0,
      "value": "Correo electrónico"
    }
  ],
  "registration.error.title": [
    {
      "type": 0,
      "value": "Registro Fallido"
    }
  ],
  "registration.facebook.button": [
    {
      "type": 0,
      "value": "Registrarse con Facebook"
    }
  ],
  "registration.firstname": [
    {
      "type": 0,
      "value": "Primer nombre"
    }
  ],
  "registration.form-legend": [
    {
      "type": 0,
      "value": "Información de Cuenta"
    }
  ],
  "registration.google.button": [
    {
      "type": 0,
      "value": "Regístrate con Google"
    }
  ],
  "registration.lastname": [
    {
      "type": 0,
      "value": "Apellido"
    }
  ],
  "registration.page-title": [
    {
      "type": 0,
      "value": "Registrarse | WiseMapping"
    }
  ],
  "registration.password": [
    {
      "type": 0,
      "value": "Contraseña"
    }
  ],
  "registration.recaptcha-notice": [
    {
      "type": 0,
      "value": "Este sitio está protegido por reCAPTCHA y se aplican la "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Política de Privacidad"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": " y los "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Términos de Servicio"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " de Google."
    }
  ],
  "registration.register": [
    {
      "type": 0,
      "value": "Registrarse"
    }
  ],
  "registration.success.already-activated": [
    {
      "type": 0,
      "value": "Already activated your account?"
    }
  ],
  "registration.success.check-spam": [
    {
      "type": 0,
      "value": "If you don't see the email, please check your spam folder."
    }
  ],
  "registration.success.email-sent": [
    {
      "type": 0,
      "value": "We've sent an activation email to your inbox. Please check your email and click on the activation link to activate your account."
    }
  ],
  "registration.success.title": [
    {
      "type": 0,
      "value": "Registration Successful!"
    }
  ],
  "registration.title": [
    {
      "type": 0,
      "value": "Hazte miembro"
    }
  ],
  "rename.description": [
    {
      "type": 0,
      "value": "Por favor, complete el nuevo nombre y descripción del mapa."
    }
  ],
  "rename.title": [
    {
      "type": 0,
      "value": "Renombrar"
    }
  ],
  "reset-password.confirm-password": [
    {
      "type": 0,
      "value": "Confirm new password"
    }
  ],
  "reset-password.desc": [
    {
      "type": 0,
      "value": "Enter your new password below."
    }
  ],
  "reset-password.invalid-link": [
    {
      "type": 0,
      "value": "Invalid password reset link. Please request a new one."
    }
  ],
  "reset-password.mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match."
    }
  ],
  "reset-password.page-title": [
    {
      "type": 0,
      "value": "Reset Password | WiseMapping"
    }
  ],
  "reset-password.password": [
    {
      "type": 0,
      "value": "New password"
    }
  ],
  "reset-password.request-new": [
    {
      "type": 0,
      "value": "Request new link"
    }
  ],
  "reset-password.submit": [
    {
      "type": 0,
      "value": "Set new password"
    }
  ],
  "reset-password.title": [
    {
      "type": 0,
      "value": "Set a new password"
    }
  ],
  "reset-password.too-long": [
    {
      "type": 0,
      "value": "Password must be less than 40 characters."
    }
  ],
  "reset-password.too-short": [
    {
      "type": 0,
      "value": "Password must be at least 8 characters."
    }
  ],
  "role.editor": [
    {
      "type": 0,
      "value": "Editor"
    }
  ],
  "role.owner": [
    {
      "type": 0,
      "value": "Dueño"
    }
  ],
  "role.viewer": [
    {
      "type": 0,
      "value": "Espectador"
    }
  ],
  "share.add-button": [
    {
      "type": 0,
      "value": "Compartir"
    }
  ],
  "share.add-message": [
    {
      "type": 0,
      "value": "Agregar mensaje"
    }
  ],
  "share.adding-button": [
    {
      "type": 0,
      "value": "Compartiendo..."
    }
  ],
  "share.can-edit": [
    {
      "type": 0,
      "value": "Puede editar"
    }
  ],
  "share.delete": [
    {
      "type": 0,
      "value": "Eliminar colaborador"
    }
  ],
  "share.delete-description": [
    {
      "type": 0,
      "value": "Añade colaboradores. Recibirán acceso instantáneo por email para editar juntos."
    }
  ],
  "share.delete-title": [
    {
      "type": 0,
      "value": "Compartir con la otros"
    }
  ],
  "share.message": [
    {
      "type": 0,
      "value": "Mensaje"
    }
  ],
  "share.table.actions": [
    {
      "type": 0,
      "value": "Actions"
    }
  ],
  "share.table.collaborator": [
    {
      "type": 0,
      "value": "Collaborator"
    }
  ],
  "share.table.role": [
    {
      "type": 0,
      "value": "Role"
    }
  ],
  "theme.dark": [
    {
      "type": 0,
      "value": "Oscuro"
    }
  ],
  "theme.light": [
    {
      "type": 0,
      "value": "Claro"
    }
  ],
  "theme.toggle": [
    {
      "type": 0,
      "value": "Cambiar Tema"
    }
  ],
  "validation.title-required": [
    {
      "type": 0,
      "value": "El título es obligatorio"
    }
  ]
}
